import register from '../../../../global/js/registry';
export default register('o-heating-form', () => import(/* webpackMode: "lazy" */ './o-heating-form.controller'));
